export const getTurnstileSiteKey = (mode = 'visible') => {
  if (typeof window !== 'undefined' && window.__E2E__) {
    return '1x00000000000000000000AA' // CF always-passes test key
  }

  return mode === 'invisible'
    ? process.env.INVISIBLE_TURNSTILE_SITE_KEY
    : process.env.VISIBLE_TURNSTILE_SITE_KEY
}
